import React from 'react'
import GameInfo from './GameInfo'
import Roster from './Roster'
import { _ } from './i18n'
import './App.scss'

class App extends React.Component {

    constructor( props ) {

        super( props )

        this.state = {

            data:   null,
            error:  null,
            loaded: false,
            sort:   'name'

        }

    }

    componentDidMount() {

        // const url = new URL( 'http://localhost:3000/roster/data.json' )
        const url = new URL( 'https://api.hockeydata.net/data_af/af/OfficialRoster' )

        const params = {

            // apiKey:  'ec57a3dd14133424555a1a6fd2804333',
            // referer: 'archive.football.at',
            gameId:  window.location.search.substr( 1 )

        }

        const init = {
            cache:       'no-cache',
            credentials: 'same-origin',
            method:      'GET',
            mode:        'cors',
            redirect:    'follow',
            referrer:    'no-referrer'
        }

        url.search = new URLSearchParams( params ).toString()

        fetch( url, init ).then( response => response.json() ).then( data => this.setData( data ) ).catch( error => this.setError( error ) )

    }

    handleToggleSort() {

        this.setState( { sort: this.state.sort === 'name' ? 'jerseyNr' : 'name' } )

    }

    setData( e ) {

        // console.log( 'setData', e )

        e.statusId > 0 ? this.setState( { loaded: true, data: e.data } ) : this.setError( e )

    }

    setError( e ) {

        // console.log( 'setError', e )

        this.setState( { loaded: true, error: e ? ( e.statusMsg || e.message || JSON.stringify( e ) ) : 'Unknown Error' } )

    }

    render() {

        const d    = this.state.data
        const rows = d ? (d.homeRoster.length > d.awayRoster.length ? d.homeRoster.length : d.awayRoster.length ) : null

        return (

            this.state.loaded

            ?

            (

                this.state.error

                ?

                <div className="error">{ this.state.error }</div>

                :

                <>

                    <GameInfo sort={ this.state.sort } game={d} onToggleSort={ () => this.handleToggleSort() } />

                    <Roster sort={ this.state.sort } team={ d.homeTeamLongname } roster={ d.homeRoster } rows={ rows } />

                    <Roster sort={ this.state.sort } team={ d.awayTeamLongname } roster={ d.awayRoster } rows={ rows } />

                    <footer>

                        <div className="powered-by">powered by hockeydata</div>

                        { _( d.rosterStatus === 'READY_TO_PLAY' ? 'OFFICIAL' : 'UNOFFICIAL' ) } { _( 'Game Roster' ) }, { _( 'Last Update' ) }: { d.lastRosterUpdate.formattedShort }

                    </footer>

                </>

            )

            :

            <></>

        )

    }

}

export default App